import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./CopyPasteFlowAnimation.css";

const CopyPasteFlowAnimation = () => {
  const [phase, setPhase] = useState("waiting");
  const [bubbleText, setBubbleText] = useState("Two Sum");
  const [resetKey, setResetKey] = useState(0);

  useEffect(() => {
    let timeouts = [];

    const startSequence = () => {
      setPhase("dragging");
      timeouts.push(setTimeout(() => {
        setBubbleText("Two Number Sum");
        setPhase("landed");
      }, 1300));

      timeouts.push(setTimeout(() => setPhase("typing"), 1800));
      timeouts.push(setTimeout(() => setPhase("slide"), 3300));
      timeouts.push(setTimeout(() => setPhase("final"), 4000));
      timeouts.push(setTimeout(() => {
        setPhase("waiting");
        setBubbleText("Two Sum");
        setResetKey((prev) => prev + 1);
      }, 7000));
    };

    startSequence();
    const interval = setInterval(startSequence, 7000);

    return () => {
      clearInterval(interval);
      timeouts.forEach(clearTimeout);
    };
  }, [resetKey]);

  return (
    <div className="cpp-animation-wrapper" key={resetKey}>
      <motion.div
        layout
        className={`cpp-grid-container ${["slide", "final"].includes(phase) ? "cpp-expanded" : ""}`}
        transition={{ duration: 0.8, ease: "easeInOut" }}
      >
        {/* Problem */}
        <motion.div layout className="cpp-grid-box cpp-left-stack">
          <span className="cpp-section-label">Problem</span>

          <motion.div
            className={`cpp-import-bubble-inside ${["dragging", "landed", "typing", "final"].includes(phase) ? "visible" : "hidden"}`}
            initial={{ x: -160, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1 }}
          >
            {bubbleText}
          </motion.div>

          <div className={`cpp-placeholder-stack ${["typing", "final"].includes(phase) ? "visible" : "hidden"}`}>
            <div className="cpp-placeholder-line cpp-shade-1" />
            <div className="cpp-placeholder-line cpp-shade-2" />
            <div className="cpp-placeholder-line cpp-shade-3" />
            <div className="cpp-placeholder-line cpp-short cpp-shade-1" />
            <div className="cpp-placeholder-line cpp-shade-2" />
          </div>
        </motion.div>

        {/* Center Panels */}
        {phase === "final" && (
          <>
            <motion.div layout className="cpp-grid-box cpp-top-left">
              <span className="cpp-section-label">Processing</span>
            </motion.div>

            <motion.div layout className="cpp-grid-box cpp-bottom-left">
              <span className="cpp-section-label">BlockCode Solution</span>
            </motion.div>
          </>
        )}

        {/* Code */}
        <motion.div layout className="cpp-grid-box cpp-top-right">
          <span className="cpp-section-label">Code</span>
          <div className="cpp-code-shell" />
        </motion.div>

        {/* Output */}
        <motion.div layout className="cpp-grid-box cpp-bottom-right">
          <span className="cpp-section-label">Output</span>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default CopyPasteFlowAnimation;
